import { Component } from '@angular/core';

// modal
import { AdminService } from '../../services/admin.service';
import { NetworkStatusService } from '../../services/network-status.service';

@Component({
  selector: 'network-loss',
  templateUrl: './network-loss.html'
})

export class NetworkLossComponent {

  constructor(
    public networkStatusService: NetworkStatusService,
    public adminService: AdminService
  ) { }

  openSuperSecretAdminKeypad(): void {
    this.adminService.showContent = true;
  }

}



// WEBPACK FOOTER //
// ./src/components/network-loss/network-loss.component.ts